// @flow

// Returns a clean endpoint without query params
const parseEndpoint = (endpoint: string): string => endpoint.substring(0, endpoint.indexOf('?')) || endpoint;

export default parseEndpoint;
